import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { ProductIntro } from './components/ProductIntro';
import { WhatsIncluded } from './components/WhatsIncluded';
import { WhoItsFor } from './components/WhoItsFor';
import { ThreeSteps } from './components/ThreeSteps';
import { BonusSection } from './components/BonusSection';
import { PricingBundle } from './components/PricingBundle';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { ContactSection } from './components/ContactSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen font-nunito text-gray-800 bg-light-pink selection:bg-pink-400 selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPoints data-id="element-2" />
      <ProductIntro data-id="element-3" />
      <WhatsIncluded data-id="element-4" />
      <WhoItsFor data-id="element-5" />
      <ThreeSteps data-id="element-6" />
      <BonusSection data-id="element-7" />
      <PricingBundle data-id="element-8" />
      <Testimonials data-id="element-9" />
      <FAQ data-id="element-10" />
      <ContactSection data-id="element-11" />
      <FinalCTA data-id="element-12" />
      <Footer data-id="element-13" />
    </div>;
}